// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {586: "recorder",621: "profiler",}[chunkId] + "-internal-e2687c52-bcf4-4f57-aada-637b3836b4d1-" + {586: "684dfbd84974ed07",621: "bfb04317d737a36b",}[chunkId] + ".js"
}